import React from 'react';

import * as S from './styles';
import BoxToChoiceBanner from 'components/BoxToChoiceBanner';
import { DataFormProps } from 'types/InputsGridOfBannersProps';

interface TripleBannerLeftProps {
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
	setIsFormBannerOpen: React.Dispatch<React.SetStateAction<boolean>>;
	deleteBanner: any;
	bannerEditedFunction: any;
}

export default function TripleBannerLeft({
	dataForm,
	setDataForm,
	setIsFormBannerOpen,
	deleteBanner,
	bannerEditedFunction
}: TripleBannerLeftProps) {
	return (
		<S.container>
			<div>
				<BoxToChoiceBanner
					setOpenForm={setIsFormBannerOpen}
					banner={dataForm?.banners[0] || null}
					dataForm={dataForm}
					setDataForm={setDataForm}
					deleteBanner={deleteBanner}
					bannerEditedFunction={bannerEditedFunction}
				/>

				<BoxToChoiceBanner
					setOpenForm={setIsFormBannerOpen}
					banner={dataForm?.banners[1] || null}
					dataForm={dataForm}
					setDataForm={setDataForm}
					deleteBanner={deleteBanner}
					bannerEditedFunction={bannerEditedFunction}
				/>
			</div>
			<BoxToChoiceBanner
				setOpenForm={setIsFormBannerOpen}
				banner={dataForm?.banners[2] || null}
				dataForm={dataForm}
				setDataForm={setDataForm}
				deleteBanner={deleteBanner}
				bannerEditedFunction={bannerEditedFunction}
			/>
		</S.container>
	);
}
